import React, { useCallback, useRef, useState } from "react";
import { useSelector } from "react-redux";
import "./CheckOut.css";
import Navbar from "../Navbar/Navbar";
import { useEffect } from "react";
import { Accordion, Card, Dropdown, ListGroup } from "react-bootstrap";
import PaymentOptions from "./PaymentOptions";
import AddressChangeModal from "./AddressChangeModal";
import axios from "axios";
import jwtDecode from "jwt-decode";
import { router, useLocation, useNavigate, useParams } from "react-router-dom";
import AddressUpdateModal from "./AddressUpdateModal";
import PersonalDetails from "./PersonalDetails";
import DeleteConfirmationModal from "./DeleteConfirmationModal";
import { ToastContainer, toast } from "react-toastify";
import Badge from "react-bootstrap/Badge";
import { Tabs, Tab } from "react-bootstrap";
import PendingFood from "./PendingFood";
import ShowOrderStatus from "./ShowOrderStatus";
import RestaurantOrder from "../Cart/Components/RestaurantOrder";
import RestaurantOrderDetails from "./RestaurantOrderDetails/RestaurantOrderDetails";
import OrderDetailsModal from "./OrderDetailsModal/OrderDetailsModal";
import PendingFoodCard from "./PendingFoodCard";
import { getPercentageOrAmount } from "../../utils/getPercentageOrAmount";
import PendingOrderAccordion from "./components/PendingOrderAccordion";
import LoyalitySchemeAccordion from "./components/LoyalitySchemeAccordion";
import SelfCollectionCard from "./components/SelfCollectionCard/SelfCollectionCard";
import DeliveryAddressCard from "./components/DeliveryAddressCard/DeliveryAddressCard";
import { colors, Dialog, DialogContent } from "@mui/material";
import Footer from "../../components/Footer/Footer";
import { Modal, Button } from "react-bootstrap";
import { QRCodeCanvas } from "qrcode.react";
import FailIcon from "./../../Assets/Image/alert.gif";
import LoadingModal from "../../components/LoadingModal";
import { ceil } from "lodash";
import WaitStatusList from "./components/WaitStatusList/WaitStatusList";
import VerificationModal from "./components/VerificationModal/VerificationModal";

const CheckOut = () => {
  const [showQR, setShowQR] = useState(false);
  const [qrOrderId, setQrOrderId] = useState(null);
  const qrUrl = `http://localhost:3001/order-details/${qrOrderId}`;
  const returnUrl = `${window.location.origin}/confirmationpage`;
  const test3Ref = useRef(null);
  const [blur, setBlur] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [address, setAddress] = useState([]);
  const [selectedAddressIdByRestaurant, setSelectedAddressIdByRestaurant] =
    useState({});
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [navbarOnTop, setNavbarOnTop] = useState(true);
  const [scrollValue, setscrollValue] = useState(0);
  const [slideUp, setSlideUp] = useState(false);
  const checkOutTopRef = useRef(null);
  const [selectedButton, setSelectedButton] = useState(null);
  const [userId, setUserId] = useState();
  const [cartData, setCartData] = useState(null);
  const [deliveredItem, setDeliveredItem] = useState([]);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [selectedAddressForUpdate, setSelectedAddressForUpdate] =
    useState(null);
  const [selectedAddressForDeletion, setSelectedAddressForDeletion] =
    useState(null);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [addressSelected, setAddressSelected] = useState(false);
  const [showAddressError, setShowAddressError] = useState(false);
  const [showCartDataError, setShowCartDataError] = useState(false);
  const [userCartData, setUserCartData] = useState([]);
  const [orderData, setOrderData] = useState([]);
  const [flattenFoodItems, setFlattenFoodItems] = useState([]);
  const [selectedTable, setSelectedTable] = useState([]);
  const [isPlaceOrderButtonHide, setIsPlaceOrderButtonHide] = useState(false);
  const [showSelfCollection, setShowSelfCollection] = useState(false);
  const [showDeliveryAddress, setShowDeliveryAddress] = useState(false);
  const [isToggleOn, setIsToggleOn] = useState(false);
  const [deliveryAddress, setDeliveryAddress] = useState([]);
  const totalCount = useSelector((state) => state.cart.totalCount);
  const itemsUpdated = useSelector((state) => state.updateCartItems.updated);
  const [hasDisabledDelivery, setHasDisabledDelivery] = useState(false);
  const [eligibleCredits, setEligibleCredits] = useState([]);
  const [totalEligibleCredit, setTotalEligibleCredit] = useState(0);
  const [userDetails, setUserDetails] = useState({});
  const [tips, setTips] = useState(0);
  const [totalServiceCharge, setTotalServiceCharge] = useState(0);
  const [serviceChargeVat, setServiceChargeVat] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [deliveryDistance, setDeliveryDistance] = useState(0);
  const [deliveryDuration, setDeliveryDuration] = useState(0);
  const [waitStateItems, setWaitStateItems] = useState([]);
  const [isUserVerified, setIsUserVerified] = useState(false);
  const [verificationChecked, setVerificationChecked] = useState(false);
  const [showVerificationModal, setShowVerificationModal] = useState(false);
  const [hasDeliveryOrCollection, setHasDeliveryOrCollection] = useState(false);

  const handleSubOrderTypeChange = useCallback(
    (subOrderId, newOrderType, itemId = null) => {
      setUserCartData((prev) =>
        prev.map((restaurant) =>
          restaurant.subOrders.some((so) => so.subOrderId === subOrderId)
            ? {
                ...restaurant,
                subOrders: restaurant.subOrders.map((so) =>
                  so.subOrderId === subOrderId
                    ? {
                        ...so,
                        // If no itemId, update the entire subOrder type
                        ...(itemId === null && { orderTypeName: newOrderType }),
                        itemDetails: so.itemDetails.map((item) =>
                          itemId && item.foodItemId === itemId
                            ? { ...item, effectiveOrderType: newOrderType }
                            : // If full subOrder toggle, clear overrides
                              itemId === null
                              ? { ...item, effectiveOrderType: undefined }
                              : item,
                        ),
                      }
                    : so,
                ),
              }
            : restaurant,
        ),
      );
    },
    [],
  );

  const [
    serviceChargeEnabledByRestaurant,
    setServiceChargeEnabledByRestaurant,
  ] = useState({});
  const [serviceChargeByRestaurant, setServiceChargeByRestaurant] = useState(
    {},
  );
  const [serviceChargeVatByRestaurant, setServiceChargeVatByRestaurant] =
    useState({});
  const [openPaymentDialog, setopenPaymentDialog] = React.useState(false);

  const [deliveryEstimate, setDeliveryEstimate] = useState({
    distanceKm: null,
    fee: 0,
    loading: false,
    error: null,
  });
  const [deliveryFeeByRestaurant, setDeliveryFeeByRestaurant] = useState({});

  useEffect(() => {
    calculateRealDistance();
  }, [userCartData, selectedAddressIdByRestaurant, address]);

  const calculateRealDistance = useCallback(() => {
    if (!window.google?.maps?.DistanceMatrixService) {
      const timer = setTimeout(calculateRealDistance, 500);
      return () => clearTimeout(timer);
    }

    if (!userCartData?.length || !address?.length) return;

    const deliveryRestaurants = userCartData.filter((cart) =>
      cart.subOrders.some((subOrder) => {
        // Check if ANY item in this subOrder is effectively set to "Delivery"
        return subOrder.itemDetails.some((item) => {
          // Determine the actual type: use effectiveOrderType if set, otherwise fallback to subOrder type
          const effectiveType =
            item.effectiveOrderType ?? subOrder.orderTypeName;

          // Must be effectively Delivery AND physically capable of delivery
          return (
            effectiveType === "Delivery" &&
            item.isDelivery &&
            !item.isCollectionOnly
          );
        });
      }),
    );

    if (deliveryRestaurants.length === 0) {
      setDeliveryEstimate({ fee: 0, loading: false, error: null });
      setDeliveryFeeByRestaurant({});
      return;
    }

    setDeliveryEstimate((prev) => ({ ...prev, loading: true, error: null }));

    let completed = 0;
    let totalFee = 0;
    const perRestaurantFee = {};

    deliveryRestaurants.forEach((cart) => {
      const rid = cart.cartRestaurantId;
      const selectedAddressId = selectedAddressIdByRestaurant[rid];
      const deliveryAddr = address.find((a) => a.id === selectedAddressId);

      const origin = cart.addressLine1?.trim();
      const destination = deliveryAddr?.address?.trim();

      if (!origin || !destination) {
        perRestaurantFee[rid] = 0;
        completed++;
        if (completed === deliveryRestaurants.length) finalize();
        return;
      }

      const service = new window.google.maps.DistanceMatrixService();

      service.getDistanceMatrix(
        {
          origins: [origin],
          destinations: [destination],
          travelMode: window.google.maps.TravelMode.DRIVING,
          unitSystem: window.google.maps.UnitSystem.METRIC,
        },
        (response, status) => {
          completed++;
          let fee = 0;
          if (status === "OK" && response?.rows?.[0]?.elements?.[0]) {
            const el = response.rows[0].elements[0];
            if (el.status === "OK") {
              const km = el.distance.value / 1000;
              const miles = parseFloat((km / 1.60934).toFixed(2));

              // minimum delivery fee is 2.99 and we add 1.5 per mile after the first mile
              if (miles < 1) {
                fee = 2.99;
              } else {
                fee = parseFloat((2.99 + (miles - 1) * 1.5).toFixed(2));
              }

              setDeliveryDistance(parseFloat(miles.toFixed(2)));
              setDeliveryDuration(ceil(el.duration.value / 60) + 12);
            }
          }
          perRestaurantFee[rid] = fee;
          totalFee += fee;

          if (completed === deliveryRestaurants.length) finalize();
        },
      );
    });

    function finalize() {
      setDeliveryFeeByRestaurant(perRestaurantFee);
      setDeliveryEstimate({
        fee: parseFloat(totalFee.toFixed(2)),
        loading: false,
        error: null,
      });
    }
  }, [userCartData, selectedAddressIdByRestaurant, address]);

  // Place order button validtion for table selection
  useEffect(() => {
    const hasInStore = userCartData.some(
      (item) =>
        item.subOrders &&
        item.subOrders.some(
          (subOrder) => subOrder.orderTypeName === "In-Store",
        ),
    );
    setIsPlaceOrderButtonHide(hasInStore);
  }, [userCartData]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // For tab change handling
  const [key, setKey] = useState("active");

  const location = useLocation();
  const onTabSelect = (k) => {
    setKey(k);
    navigate(`/checkout?tab=${k}`, { replace: true });
  };
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get("tab");

    if (tab) {
      setKey(tab);
    }
  }, [location.search]);

  /* showing the pending tab automatically */
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const forPending = params.get("for");
  useEffect(() => {
    if (forPending === "pending") {
      setKey("pending");
    }
  }, [forPending]);

  const navigate = useNavigate();

  const proceedWithOrderSubmission = async (skipLoyalty = false) => {
    // Prevent duplicate submissions
    if (isSubmitting) return;
    setIsSubmitting(true);

    try {
      // 1. Validate cart exists
      const cartExistsResponse = await axios.get(
        `${process.env.REACT_APP_SECRET}/api/Cart/IsCartExist/${userId}`,
      );
      if (cartExistsResponse.data === false) {
        setShowModal(true);
        return;
      }

      // 2. Table selection validation (for In-Store)
      if (isPlaceOrderButtonHide) {
        const inStoreRestaurants = userCartData
          .filter((item) =>
            item.subOrders?.some((sub) => sub.orderTypeName === "In-Store"),
          )
          .map((item) => ({
            id: item.cartRestaurantId,
            name: item.restaurantName,
          }));

        const selectedRestaurantIds =
          selectedTable?.map((t) => t.restaurantId) || [];
        const missingRestaurants = inStoreRestaurants.filter(
          (res) => !selectedRestaurantIds.includes(res.id),
        );

        if (missingRestaurants.length > 0) {
          const firstMissing = missingRestaurants[0];
          const section = document.getElementById(
            `restaurant-table-section-${firstMissing.id}`,
          );
          if (section) {
            section.scrollIntoView({ behavior: "smooth", block: "center" });
          }
          toast.info(
            missingRestaurants.length === 1
              ? `Please select a table for the restaurant "${firstMissing.name}" before placing your order.`
              : "Please select tables for all restaurants before placing your order.",
          );
          return;
        }
      }

      // 3. Wait state validation
      const waitStateItems = [];
      try {
        const allFoodItems = userCartData.flatMap((restaurant) =>
          restaurant.subOrders.flatMap((subOrder) =>
            subOrder.itemDetails.map((item) => ({
              foodItemId: item.foodItemId,
              restaurantId: restaurant.cartRestaurantId,
              foodItemName: item.foodItemName,
              restaurantName: restaurant.restaurantName,
            })),
          ),
        );

        const waitStatusPromises = allFoodItems.map(async (item) => {
          const apiResponse = await axios.get(
            `${process.env.REACT_APP_SECRET}/api/Cart/GetFoodItemWaitStatus`,
            {
              params: {
                foodItemId: item.foodItemId,
                restaurantId: item.restaurantId,
              },
            },
          );
          return { ...item, isInWaitState: apiResponse.data === true };
        });

        const results = await Promise.all(waitStatusPromises);
        results.forEach((result) => {
          if (result.isInWaitState) {
            waitStateItems.push(result);
          }
        });
      } catch (error) {
        console.error("Error checking food item wait status:", error);
        toast.error("Failed to validate item availability. Please try again.");
        return;
      }

      if (waitStateItems.length > 0) {
        setWaitStateItems(waitStateItems);
        localStorage.setItem("waitStateItems", JSON.stringify(waitStateItems));
        toast.error(
          `Some items are temporarily unavailable:\n${waitStateItems
            .map((i) => `- ${i.foodItemName} (${i.restaurantName})`)
            .join("\n")}`,
        );
        return;
      }

      // 4. Prepare order data
      setModalOpen(true);

      const reqBody = userCartData.map((restaurant) => {
        // 👇 Skip loyalty credit if requested
        const appliedCredit = skipLoyalty
          ? 0
          : (() => {
              const availableCredit = eligibleCredits.find(
                (credit) =>
                  credit.restaurantId === restaurant.cartRestaurantId &&
                  credit.eligibleForCredit,
              );
              return availableCredit ? availableCredit.creditLimitPerOrder : 0;
            })();

        const foodItems = restaurant.subOrders.flatMap((subOrder) =>
          subOrder.itemDetails.map((item) => ({
            foodItemId: item.foodItemId,
            foodItemName: item.foodItemName,
          })),
        );

        return {
          cartId: restaurant.cartId,
          restaurantId: restaurant.cartRestaurantId,
          tip: restaurantTips[restaurant.cartRestaurantId] || 0,
          appliedCredit,
          foodItems,
          isServiceChargeAdded:
            serviceChargeEnabledByRestaurant[restaurant.cartRestaurantId] ??
            false,
        };
      });

      // 5. Prepare payment data per restaurant
      const paymentDataArray = userCartData.map((restaurant) => {
        const rId = restaurant.cartRestaurantId;
        const perSC = serviceChargeByRestaurant[rId] || 0;
        const perSCVat = serviceChargeVatByRestaurant[rId] || 0;

        let rSubTotal = 0;
        let rTotalVAT = 0;
        let rTotalSD = 0;
        restaurant.subOrders?.forEach((subOrder) => {
          subOrder.itemDetails.forEach((item) => {
            rSubTotal += item.basePrice * item.foodItemQuantity;
            rTotalVAT += item.vatInAmount * item.foodItemQuantity;
            rTotalSD += item.sdInAmount * item.foodItemQuantity;
            (item.addOns || []).forEach((addOn) => {
              rSubTotal += addOn.addOnBasePrice * addOn.addOnQuantity;
              rTotalVAT += addOn.addOnVatAmount * addOn.addOnQuantity;
              rTotalSD += addOn.addOnSdAmount * addOn.addOnQuantity;
              (addOn.options || []).forEach((option) => {
                rSubTotal += option.optionBasePrice * option.optionQuantity;
                rTotalVAT += option.optionVatAmount * option.optionQuantity;
                rTotalSD += option.optionSdAmount * option.optionQuantity;
                (option.subOptions || []).forEach((subOption) => {
                  const qty = subOption.subOptionQuantity ?? 1;
                  rSubTotal += subOption.subOptionBasePrice * qty;
                  rTotalVAT += (subOption.subOptionVatAmount ?? 0) * qty;
                  rTotalSD += (subOption.subOptionSdAmount ?? 0) * qty;
                });
              });
            });
          });
        });

        const hasOnline = restaurant.subOrders?.some(
          (so) => so.orderTypeName === "Online",
        );
        const rDeliveryCharge = hasOnline ? baseDeliveryCharge : 0;
        const rTips = restaurantTips[rId] || 0;

        const rTotalAmount =
          rSubTotal +
          rTotalSD +
          rTotalVAT +
          perSC +
          perSCVat +
          rTips +
          rDeliveryCharge;

        return {
          id: "",
          orderId: restaurant.cartId,
          totalAmount: Number(rTotalAmount.toFixed(2)),
          totalVAT: Number(rTotalVAT.toFixed(2)),
          totalSD: Number(rTotalSD.toFixed(2)),
          totalTips: Number(rTips.toFixed(2)),
          totalServiceCharge: Number(perSC.toFixed(2)),
          totalServiceChargeVat: Number(perSCVat.toFixed(2)),
          totalCreditGivenToCust: 0,
          platformFeeId: 0,
          totalProcessingFees: 0,
          totalCaptureFees: 0,
          totalAuthFees: 0,
          orderStatusId: "pending",
          creationId: userId,
          paidPaymentDetails: {
            id: "",
            orderPaymentId: "",
            paidAmount: Number(rTotalAmount.toFixed(2)),
            remainingAmount: 0,
            paymentDate: new Date().toISOString(),
            paymentTypeId: "",
          },
        };
      });

      // 6. Save to localStorage
      const fullOrderData = {
        timestamp: new Date().toISOString(),
        confirmedOrders: reqBody,
        paymentDetails: paymentDataArray,
        requestPayloads: {
          orders: reqBody,
          tips: userCartData.map((r) => ({
            cartId: r.cartId,
            tip: restaurantTips[r.cartRestaurantId] || 0,
          })),
        },
      };
      localStorage.setItem("lastOrderData", JSON.stringify(fullOrderData));

      // 7. Final total amount calculation
      const totalAmount = Number(
        (
          Number(subTotal || 0) +
          Number(totalSD || 0) +
          Number(totalVAT || 0) +
          Number(totalServiceCharge || 0) +
          Number(serviceChargeVat || 0) +
          Number(totalTips || 0) +
          Number(deliveryEstimate.fee || 0) -
          (skipLoyalty ? 0 : Number(totalEligibleCredit || 0))
        ).toFixed(2),
      );

      // 8. Get payment details & initiate checkout
      const paymentDetailsResponse = await axios.get(
        `${process.env.REACT_APP_SECRET}/api/Order/GetPaymentDetails?email=${userDetails.UserEmail}&amount=${totalAmount}&returnUrl=null`,
      );

      localStorage.setItem(
        "checkoutDetails",
        JSON.stringify(paymentDetailsResponse.data),
      );

      const checkout = {
        id: userDetails.UserId,
        orderPaymentId: userCartData[0]?.cartId || "",
        resultCode: paymentDetailsResponse.data?.result.code ?? "",
        resultDescription:
          paymentDetailsResponse.data?.result.description ?? "",
        buildNumber: paymentDetailsResponse.data.buildNumber ?? "",
        timestampUtc: new Date(paymentDetailsResponse.data.timestamp),
        ndc: paymentDetailsResponse.data.ndc ?? "",
        transactionId: paymentDetailsResponse.data.id ?? "",
        integrityHash: paymentDetailsResponse.data.integrity ?? "",
        createdAt: new Date().toISOString(),
      };

      await axios.post(
        `${process.env.REACT_APP_SECRET}/api/Order/InsertCartPaymentAttempts`,
        checkout,
      );

      setCheckOutId(paymentDetailsResponse.data.id);
    } catch (error) {
      console.error("Error in order/payment processing:", error);
      if (
        error.response &&
        typeof error.response.data === "string" &&
        error.response.data.includes("is in wait state")
      ) {
        toast.error(error.response.data);
      } else {
        toast.error("Error processing order. Please try again.");
      }
    } finally {
      setModalOpen(false);
      setIsSubmitting(false);
    }
  };

  const { state } = useLocation();

  const handleShowAddressModal = () => setShowAddressModal(true);
  const handleCloseAddressModal = () => setShowAddressModal(false);
  const handleAddressSelect = (restaurantId, addressId) => {
    setSelectedAddressIdByRestaurant((prev) => ({
      ...prev,
      [restaurantId]: addressId,
    }));
    setAddressSelected(true);
    setShowAddressError(false);
  };

  // UPDATED: Supports optional subOrderId (V2 API)
  const changeDeliveryAddress = async (
    address,
    currentNote = null,
    subOrderId = null,
    distance = null,
    duration = null,
  ) => {
    try {
      const noteToUse = currentNote ?? address.deliveryNote ?? null;

      if (subOrderId) {
        const cartEntry = userCartData?.find((cart) =>
          cart.subOrders.some((so) => so.subOrderId === subOrderId),
        );
        const restaurantId = cartEntry?.cartRestaurantId;
        const deliveryFee = restaurantId
          ? deliveryFeeByRestaurant[restaurantId]
          : undefined;

        // NEW V2 API: per-subOrder update with deliveryDistance & deliveryDuration
        const encodedNote = encodeURIComponent(noteToUse || "N/A");

        const params = new URLSearchParams({
          SubOrderId: subOrderId,
          deliveryAddressDetails: address.address,
          deliveryNote: encodedNote,
          ...(distance != null &&
            !isNaN(Number(distance)) && { deliveryDistance: Number(distance) }),
          ...(duration != null &&
            !isNaN(Number(duration)) && {
              estimateTime: Math.round(Number(duration)),
            }),
          ...(deliveryFee != null &&
            !isNaN(Number(deliveryFee)) && {
              deliveryFee: Number(deliveryFee).toFixed(2),
            }),
        });

        // update delivery address via V2 API + distance/duration + delivery fee
        const url = `${process.env.REACT_APP_SECRET}/api/Cart/UpdateDeliveryAddressV2?${params.toString()}`;
        const response = await axios.post(url);

        if (response.data) {
          // toast.success("Delivery address updated");
        }
        return response.data;
      } else {
        // Legacy fallback (global update – no distance/duration needed)
        const encodedAddress = encodeURIComponent(address.address);
        const encodedNote = encodeURIComponent(noteToUse);
        const response = await axios.patch(
          `${process.env.REACT_APP_SECRET}/api/Cart/UpdateDeliveryAddress?customerId=${address.userId}&deliveryAddressId=${address.id}&deliveryAddressDetails=${encodedAddress}&deliveryNote=${encodedNote}`,
          `${process.env.REACT_APP_SECRET}/api/Cart/UpdateDeliveryAddress?customerId=${address.userId}&deliveryAddressId=${address.id}&deliveryAddressDetails=${encodedAddress}&deliveryNote=${encodedNote}`,
        );

        if (response.data) {
          // toast.success("Delivery address updated");
        }
        return response.data;
      }
    } catch (error) {
      console.error("Error updating delivery address:", error);
      toast.error("Failed to update delivery address");
    }
  };

  // UPDATED: Supports optional subOrderId (V2 API)
  const updateDeliveryNote = async (addressId, newNote, subOrderId = null) => {
    try {
      const addr = address.find((a) => a.id === addressId);
      if (!addr) {
        toast.error("Address not found");
        return;
      }

      if (subOrderId) {
        // Use V2 API — update both address & note together
        const encodedAddress = encodeURIComponent(addr.address);
        const encodedNote = encodeURIComponent(newNote || "");
        const url = `${process.env.REACT_APP_SECRET}/api/Cart/UpdateDeliveryAddressV2?SubOrderId=${subOrderId}&deliveryAddressDetails=${encodedAddress}&deliveryNote=${encodedNote}`;
        const response = await axios.post(url);
        if (response.data) {
          toast.success("Delivery note updated");
        }
        return response.data;
      } else {
        // Legacy fallback (note-only update)
        const payload = {
          ...addr,
          deliveryNote: newNote,
        };
        await changeDeliveryAddress(payload, newNote);
        setAddress(
          (prev) =>
            prev.map((a) =>
              a.id === addressId ? { ...a, notes: newNote } : a,
            ),
          // prev.map((a) => (a.id === addressId ? { ...a, notes: newNote } : a)),
        );
      }
    } catch (error) {
      console.error("Failed to update delivery note:", error);
      toast.error("Failed to save delivery note");
    }
  };

  const handleCloseUpdateModal = (address) => {
    setSelectedAddressForUpdate(address);
    setShowUpdateModal(true);
  };

  const handleButtonClick = (amount) => {
    setSelectedButton(amount);
  };

  const searchDialogOpen = (NavbarData) => {
    setBlur(NavbarData);
  };

  const changeAddress = (newAddress) => {
    // Update the address in the parent component
    setAddress((prevAddresses) => [...prevAddresses, newAddress]);
  };

  const handleDeleteAddress = (id) => {
    const selectedAddress = address.find((a) => a.id === id);
    setSelectedAddressForDeletion(selectedAddress);
    setShowDeleteConfirmation(true);
  };

  const transformApiResponse = (apiResponse) => {
    // Extract the userId and restaurantId from the first subOrder
    const userId = apiResponse[0].customerId;
    // Initialize an empty array for restaurantIds
    const restaurantIds = [];
    // Loop through each subOrder to get the restaurantId and foodItemIds
    apiResponse.forEach((cart) => {
      const restaurantId = cart.cartRestaurantId;
      const foodItemIds = [];
      // Loop through subOrders to extract the foodItemId
      cart.subOrders.forEach((subOrder) => {
        subOrder.itemDetails.forEach((itemDetail) => {
          foodItemIds.push({ foodItemId: itemDetail.foodItemId });
        });
      });
      // Push the restaurantId and foodItemIds into the result array
      restaurantIds.push({
        restaurantId: restaurantId,
        foodItemIds: foodItemIds,
      });
    });
    // Return the final transformed data
    return {
      userId: userId,
      restaurantIds: restaurantIds,
    };
  };

  useEffect(() => {
    const userId = localStorage.getItem("gotasteClienttoken");
    const decoded = jwtDecode(userId);
    const getCartData = async (userId) => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_SECRET}/api/Cart/GetCartDataByUserId?userId=${userId}`,
          `${process.env.REACT_APP_SECRET}/api/Cart/GetCartDataByUserId?userId=${userId}`,
          `${process.env.REACT_APP_SECRET}/api/Cart/GetCartDataByUserId?userId=${userId}`,
        );
        const newCartData = [...response.data]; // ensure new reference
        setCartData(newCartData);
        setUserCartData(newCartData);
      } catch (error) {
        console.log(error);
      }
    };
    getCartData(decoded.UserId);
  }, [totalCount, itemsUpdated]);

  useEffect(() => {
    let hasCollection = false;
    let hasDelivery = false;

    userCartData.forEach((cart) => {
      cart.subOrders.forEach((subOrder) => {
        // Only process Delivery sub-orders
        if (subOrder.orderTypeName === "Delivery") {
          subOrder.itemDetails.forEach((item) => {
            // Determine the actual order type for this item
            const effectiveType =
              item.effectiveOrderType ?? subOrder.orderTypeName;

            // Check if the item is currently set to be delivered
            if (item.isDelivery && effectiveType === "Delivery") {
              if (item.isCollectionOnly) {
                hasCollection = true;
              } else {
                hasDelivery = true;
              }
            }
          });
        }
      });
    });

    setShowSelfCollection(hasCollection);
    setShowDeliveryAddress(hasDelivery);
  }, [userCartData]);

  // useEffect(() => {
  //   const createDeliveryAndTableData = async (reqObj) => {
  //     try {
  //       const response = await axios.post(
  //         `${process.env.REACT_APP_SECRET}/api/Cart/InsertIntoDeliverAddressAndTable`,
  //         reqObj
  //       );
  //       console.log("RRR:", response);
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   };
  //   if (userCartData.length > 0) {
  //     const transformedData = transformApiResponse(userCartData);
  //     createDeliveryAndTableData(transformedData);
  //   }
  //   // setTotalServiceCharge(calculateTotalServiceChargeWithVAT(userCartData))
  // }, [userCartData]);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const lastSubmittedHashRef = useRef(null);

  useEffect(() => {
    if (userCartData.length === 0 || isSubmitting) return; // Prevent concurrent calls

    const transformedData = transformApiResponse(userCartData);
    const currentHash = JSON.stringify(transformedData);

    if (lastSubmittedHashRef.current === currentHash) {
      console.log(
        "[InsertIntoDeliverAddressAndTable] Skipped duplicate submission",
        "[InsertIntoDeliverAddressAndTable] Skipped duplicate submission",
      );
      return;
    }

    const createDeliveryAndTableData = async () => {
      setIsSubmitting(true); // Lock
      try {
        console.log(
          "[InsertIntoDeliverAddressAndTable] Submitting...",
          currentHash,
          currentHash,
        );
        const response = await axios.post(
          `${process.env.REACT_APP_SECRET}/api/Cart/InsertIntoDeliverAddressAndTable`,
          transformedData,
        );
        console.log(
          "[InsertIntoDeliverAddressAndTable] Success:",
          response.data,
          response.data,
        );
        lastSubmittedHashRef.current = currentHash; // ✅ Update hash on success
      } catch (error) {
        console.error("[InsertIntoDeliverAddressAndTable] Failed:", error);
        toast.error("Failed to sync delivery/table data. Retrying...");
        // ❗ Do NOT update hash on failure — allows retry
      } finally {
        setIsSubmitting(false); // Unlock
      }
    };

    createDeliveryAndTableData();
  }, [userCartData, isSubmitting]);

  const handleConfirmDelete = async () => {
    try {
      // Call API to delete from DB
      await axios.delete(
        `${process.env.REACT_APP_SECRET}/api/deliveryAddress/deleteDeliveryAddress/${selectedAddressForDeletion.id}`,
      );

      // Update Local Address List
      const updatedAddresses = address.filter(
        (a) => a.id !== selectedAddressForDeletion.id,
      );
      setAddress(updatedAddresses);

      // CRITICAL FIX: Clean up selectedAddressIdByRestaurant
      setSelectedAddressIdByRestaurant((prev) => {
        const newState = { ...prev };
        Object.keys(newState).forEach((rid) => {
          if (newState[rid] === selectedAddressForDeletion.id) {
            delete newState[rid];
          }
        });
        return newState;
      });

      // Reset the main delivery estimate to 0 immediately
      setDeliveryEstimate((prev) => ({
        ...prev,
        fee: 0,
        loading: false,
        error: null,
        distanceKm: null,
      }));

      // Reset individual restaurant fees to 0 so the summary updates instantly
      setDeliveryFeeByRestaurant({});

      // Reset Error/Selection Flags
      setAddressSelected(false);
      setShowAddressError(true);

      // Close Modal
      setShowDeleteConfirmation(false);

      toast.success("Address deleted successfully");
    } catch (error) {
      console.error("Error deleting address:", error);
      toast.error("Failed to delete address");
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const filterBarRect = checkOutTopRef?.current?.getBoundingClientRect();
      if (!filterBarRect) return;
      const isAtTop = filterBarRect.top === 0;
      setNavbarOnTop(isAtTop);
      const top = -filterBarRect.top; // positive when scrolled down
      const prevScroll = -scrollValue;
      if (top > prevScroll) {
        setSlideUp(true);
      } else {
        setSlideUp(false);
      }
      setscrollValue(filterBarRect.top);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [scrollValue]); // depend on scrollValue so it updates correctly

  let gotasteClienttoken = localStorage.getItem("gotasteClienttoken");
  useEffect(() => {
    let decoded = {};
    if (gotasteClienttoken != null) {
      try {
        decoded = jwtDecode(gotasteClienttoken);
        // console.log(decoded);
      } catch (error) {
        console.log(error);
      }
    }
    if (decoded != null) {
      setUserId(decoded.UserId);
      setUserDetails(decoded);
      // getUserChatPreview(decoded.UserId);
    }
  }, [gotasteClienttoken]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_SECRET}/api/Cart/GetCartDataByUserId?userId=${userId}`,
          // `${process.env.REACT_APP_SECRET}/api/Cart?userId=${userId}`
        );
        const newCartData = [...response.data];
        setCartData(newCartData);
      } catch (error) {
        console.error("Error fetching cart data:", error);
      }
    };
    if (userId) {
      fetchData();
    }
    const handleCartUpdated = () => {
      if (userId) {
        fetchData();
      }
    };
    window.addEventListener("cartUpdated", handleCartUpdated);
    // cleanup
    return () => {
      window.removeEventListener("cartUpdated", handleCartUpdated);
    };
  }, [userId]);

  const [pendingOrders, setPendingOrders] = useState([]);
  const [historyOrders, setHistoryOrders] = useState([]);
  console.log("pendingOrders", pendingOrders);

  useEffect(() => {
    const fetchPendingOrders = async (userId) => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_SECRET}/api/Order/GetPendingOrderDataByUserIdV2?userId=${userId}`,
        );
        const allOrders = await response.data;
        console.log("History Orders:", allOrders);

        console.log("All Orders:", allOrders);
        // Pending orders
        const pending = allOrders.filter((order) => {
          if (order.orderStatus === "Refund") return false;
          // Check if any food item is still active (pending, preparing, ready, queue)
          const hasActiveItems = order.foodItems?.some(
            (item) =>
              item.foodStatus === "Pending" ||
              item.foodStatus === "Preparing" ||
              item.foodStatus === "Ready" ||
              item.foodStatus === "Queue" ||
              item.foodStatus === "En-Route" ||
              item.foodStatus === "On the way to Restaurant" ||
              item.foodStatus === "Incoming Order",
          );
          // Order is pending if it has active items OR
          // if the main order status is not served/delivered/canceled/refunded
          return (
            hasActiveItems &&
            order.orderStatus !== "Served" &&
            order.orderStatus !== "Delivered" &&
            order.orderStatus !== "Canceled" &&
            order.orderStatus !== "Refund"
          );
        });
        // History orders
        const history = allOrders.filter((order) => {
          // Directly push refund orders into history
          if (order.orderStatus === "Refund") return true;
          // Check if all food items are completed (served, delivered, canceled, refunded)
          const allItemsCompleted = order.foodItems?.every(
            (item) =>
              item.foodStatus === "Served" ||
              item.foodStatus === "Completed" ||
              item.foodStatus === "Delivered" ||
              item.foodStatus === "Canceled" ||
              item.foodStatus === "Refund",
          );
          // History if all items completed AND order status is served/delivered/canceled/refund
          return (
            allItemsCompleted &&
            (order.orderStatus === "Served" ||
              order.orderStatus === "Completed" ||
              order.orderStatus === "Delivered" ||
              order.orderStatus === "Canceled" ||
              order.orderStatus === "Refund")
          );
        });
        console.log("Pending Orders:", pending);
        console.log("History Orders:", history);
        setPendingOrders(pending);
        setHistoryOrders(history);
      } catch (error) {
        console.error(error);
      }
    };
    if (userId) {
      fetchPendingOrders(userId);
    }
  }, [userId]);

  // ✅ UPDATED: initialize per-restaurant address selection
  useEffect(() => {
    const fetchAddresses = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_SECRET}/api/deliveryAddress/getDeliveryAddressByUserId/${userId}`,
        );
        // Assuming the response.data is an array of addresses
        // Update your state with the fetched addresses
        setAddress(response.data);
        const defaultAddress = response.data.find(
          (add) => add.isDefault === true,
          (add) => add.isDefault === true,
        );
        // ✅ Initialize per-restaurant selection
        if (defaultAddress && userCartData?.length > 0) {
          const initMap = {};
          userCartData.forEach((cart) => {
            initMap[cart.cartRestaurantId] = defaultAddress.id;
          });
          setSelectedAddressIdByRestaurant(initMap);
        }
      } catch (error) {
        console.error("Error fetching addresses:", error);
        // Handle errors, e.g., show an error message to the user
      }
    };
    // Call the fetchAddresses function when the component mounts
    if (userId) fetchAddresses();
  }, [userId, userCartData]); // ← added userCartData to deps

  const RefetchAddresses = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SECRET}/api/deliveryAddress/getDeliveryAddressByUserId/${userId}`,
      );
      setAddress(response.data);
      const defaultAddress = response.data.find(
        (add) => add.isDefault === true,
        (add) => add.isDefault === true,
      );
      if (defaultAddress && userCartData?.length > 0) {
        const initMap = {};
        userCartData.forEach((cart) => {
          initMap[cart.cartRestaurantId] = defaultAddress.id;
        });
        setSelectedAddressIdByRestaurant(initMap);
      }
    } catch (error) {
      console.error("Error fetching addresses:", error);
      // Handle errors, e.g., show an error message to the user
    }
  };

  // ...
  const handleUpdateDefaultAddress = async (id, userId) => {
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_SECRET}/api/deliveryAddress/${id}?userId=${userId}`,
      );
      if (response.data > 0) {
        RefetchAddresses();
      }
    } catch (error) {
      console.log(error);
    }
  };

  // const updateServiceCharge = (newCharge) => {
  //   setTotalServiceCharge((prevTotal) => prevTotal + newCharge);
  // };

  // Initialize per-restaurant service charge toggles (default ON for all; mandatory stays ON)
  useEffect(() => {
    if (userCartData && userCartData.length > 0) {
      setServiceChargeEnabledByRestaurant((prev) => {
        const next = { ...prev };
        userCartData.forEach((cart) => {
          // default to ON if not set
          if (next[cart.cartRestaurantId] === undefined) {
            next[cart.cartRestaurantId] = true;
          }
          // if mandatory, force ON
          if (cart.isServiceChargeCom === true) {
            next[cart.cartRestaurantId] = true;
          }
        });
        return next;
      });
    }
  }, [userCartData]);

  // Debug: Log service charge state changes
  useEffect(() => {
    console.log(
      "CheckOut: serviceChargeEnabledByRestaurant:",
      serviceChargeEnabledByRestaurant,
    );
  }, [serviceChargeEnabledByRestaurant, userCartData]);

  useEffect(() => {
    // Calculate per-restaurant service charge and VAT (In-Store only)
    if (!userCartData || userCartData.length === 0) {
      setServiceChargeByRestaurant({});
      setServiceChargeVatByRestaurant({});
      setTotalServiceCharge(0);
      setServiceChargeVat(0);
      return;
    }
    const nextSC = {};
    const nextVat = {};
    userCartData.forEach((cart) => {
      const rid = cart.cartRestaurantId;
      const enabled = serviceChargeEnabledByRestaurant[rid] ?? true;
      if (!enabled) {
        nextSC[rid] = 0;
        nextVat[rid] = 0;
        return;
      }
      let sub = 0;
      cart.subOrders.forEach((s) => {
        if (s.orderTypeName !== "In-Store") return;
        s.itemDetails.forEach((i) => {
          sub += i.basePrice * i.foodItemQuantity;
          i.addOns.forEach((a) => {
            sub += a.addOnBasePrice * a.addOnQuantity;
            a.options.forEach((o) => {
              sub += o.optionBasePrice * o.optionQuantity;
              o.subOptions.forEach((ss) => {
                const qty = ss.subOptionQuantity ?? 1;
                sub += ss.subOptionBasePrice * qty;
              });
            });
          });
        });
      });
      const sc = getPercentageOrAmount(sub, cart.serviceCharge, "amount");
      const vat = (sc * 20) / 100;
      nextSC[rid] = sc;
      nextVat[rid] = vat;
    });
    setServiceChargeByRestaurant(nextSC);
    setServiceChargeVatByRestaurant(nextVat);
    setTotalServiceCharge(Object.values(nextSC).reduce((a, b) => a + b, 0));
    setServiceChargeVat(Object.values(nextVat).reduce((a, b) => a + b, 0));
  }, [userCartData, serviceChargeEnabledByRestaurant]);

  const [restaurantTips, setRestaurantTips] = useState({}); // Store tips for each restaurant
  const [totalTips, setTotalTips] = useState(0);

  const calculateTotalTips = (tips) => {
    const total = Object.values(tips).reduce((acc, curr) => acc + curr, 0);
    setTotalTips(total);
  };

  const handleServiceChargeToggle = useCallback(
    (restaurantId) => {
      const cart = userCartData?.find(
        (c) => c.cartRestaurantId === restaurantId,
      );
      if (!cart) return;
      if (cart.isServiceChargeCom === false) {
        setServiceChargeEnabledByRestaurant((prev) => ({
          ...prev,
          [restaurantId]: !(prev[restaurantId] ?? true),
        }));
      }
    },
    [userCartData],
  );

  const handleSetTip = (restaurantId, tip, type) => {
    if (type === "amount") {
      setRestaurantTips((prevTips) => {
        const updatedTips = { ...prevTips, [restaurantId]: tip };
        calculateTotalTips(updatedTips); // Recalculate total tips whenever a tip is updated
        return updatedTips;
      });
    } else if (type === "percentage") {
      let total =
        subTotal +
        totalSD +
        totalVAT +
        totalServiceCharge +
        deliveryCharge +
        totalServiceCharge * 0.2;
      total = total.toFixed(2);
      const tipAmount = getPercentageOrAmount(total, tip, "amount");
      setRestaurantTips((prevTips) => {
        const updatedTips = { ...prevTips, [restaurantId]: tipAmount };
        calculateTotalTips(updatedTips); // Recalculate total tips whenever a tip is updated
        return updatedTips;
      });
    } else {
      throw new Error(
        "Invalid type for Tip! Type can be either amount or percentage",
      );
    }
  };

  const wpwOptions = {
    billingAddress: {
      country: "US",
      state: "NY",
      city: "New York",
      postcode: "12345",
      street1: "Suite 1234",
      street2: "Some Road",
    },
    mandatoryBillingFields: {
      country: true,
      state: true,
      city: true,
      postcode: true,
      street1: true,
      street2: false,
    },
    forceCardHolderEqualsBillingName: true,
  };

  const [checkoutId, setCheckOutId] = useState("");

  useEffect(() => {
    if (checkoutId) {
      window.wpwlOptions = {
        billingAddress: {},
        mandatoryBillingFields: {
          country: true,
          state: true,
          city: true,
          postcode: true,
          street1: true,
          street2: false,
        },
        forceCardHolderEqualsBillingName: true,
      };
      const paymentURL = process.env.REACT_APP_PAYMENT_WIDGET_URL;
      console.log("Payment URL:", paymentURL);
      const script = document.createElement("script");
      script.src = paymentURL + "?checkoutId=" + checkoutId;
      script.async = true;
      script.crossOrigin = "anonymous";
      document.body.appendChild(script);
      setopenPaymentDialog(true);
      return () => {
        document.body.removeChild(script);
      };
    }
  }, [checkoutId]);

  const handleOk = () => {
    setShowModal(false);
    window.location.reload();
  };

  const fetchUserVerificationStatus = async (userId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SECRET}/api/GoTasteUser/GetIsUserVerified/${userId}`,
      );
      setIsUserVerified(response.data);
    } catch (error) {
      console.error("Failed to fetch user verification status:", error);
      setIsUserVerified(false);
    } finally {
      setVerificationChecked(true);
    }
  };

  useEffect(() => {
    const hasDeliveryOrCollectionFlag = userCartData.some((restaurant) =>
      restaurant.subOrders.some(
        (subOrder) =>
          subOrder.orderTypeName === "Delivery" ||
          subOrder.orderTypeName === "Collection",
      ),
    );

    setHasDeliveryOrCollection(hasDeliveryOrCollectionFlag);

    if (hasDeliveryOrCollectionFlag && userId) {
      fetchUserVerificationStatus(userId);
    }
  }, [userCartData, userId, isUserVerified]);

  //   const response = await axios.get(
  //     `${process.env.REACT_APP_SECRET}/api/Cart/IsCartExist/${userId}`,
  //   );

  //   if (response.data === true) {

  //     if (isPlaceOrderButtonHide) {

  //       const inStoreRestaurants = userCartData
  //         .filter((item) =>
  //           item.subOrders?.some((sub) => sub.orderTypeName === "In-Store"),
  //         )
  //         .map((item) => ({
  //           id: item.cartRestaurantId,
  //           name: item.restaurantName,
  //         }));

  //       const selectedRestaurantIds =
  //         selectedTable?.map((t) => t.restaurantId) || [];
  //       const missingRestaurants = inStoreRestaurants.filter(
  //         (res) => !selectedRestaurantIds.includes(res.id),
  //       );
  //       if (missingRestaurants.length > 0) {
  //         const firstMissing = missingRestaurants[0];

  //         const section = document.getElementById(
  //           `restaurant-table-section-${firstMissing.id}`,
  //         );
  //         if (section) {
  //           section.scrollIntoView({ behavior: "smooth", block: "center" });
  //         }
  //         toast.info(
  //           missingRestaurants.length === 1
  //             ? `Please select a table for the restaurant "${firstMissing.name}" before placing your order.`
  //             : "Please select tables for all restaurants before placing your order.",
  //         );
  //         return;
  //       }
  //     }

  //     const waitStateItems = [];

  //     try {

  //       const allFoodItems = userCartData.flatMap((restaurant) =>
  //         restaurant.subOrders.flatMap((subOrder) =>
  //           subOrder.itemDetails.map((item) => ({
  //             foodItemId: item.foodItemId,
  //             restaurantId: restaurant.cartRestaurantId,
  //             foodItemName: item.foodItemName,
  //             restaurantName: restaurant.restaurantName,
  //           })),
  //         ),
  //       );

  //       const waitStatusPromises = allFoodItems.map(async (item) => {
  //         const apiResponse = await axios.get(
  //           `${process.env.REACT_APP_SECRET}/api/Cart/GetFoodItemWaitStatus`,
  //           {
  //             params: {
  //               foodItemId: item.foodItemId,
  //               restaurantId: item.restaurantId,
  //             },
  //           },
  //         );
  //         return { ...item, isInWaitState: apiResponse.data === true };
  //       });

  //       const results = await Promise.all(waitStatusPromises);

  //       results.forEach((result) => {
  //         if (result.isInWaitState) {
  //           waitStateItems.push(result);
  //         }
  //       });
  //     } catch (error) {
  //       console.error("Error checking food item wait status:", error);
  //       toast.error("Failed to validate item availability. Please try again.");
  //       setModalOpen(false);
  //       return;
  //     }

  //     if (waitStateItems.length > 0) {
  //       setWaitStateItems(waitStateItems);
  //       setModalOpen(false);
  //       localStorage.setItem("waitStateItems", JSON.stringify(waitStateItems));
  //       toast.error(
  //         `Some items are temporarily unavailable:\n${waitStateItems
  //           .map((i) => `- ${i.foodItemName} (${i.restaurantName})`)
  //           .join("\n")}`,
  //       );
  //       return;
  //     }

  //     if (hasDeliveryOrCollection) {
  //       let verified = isUserVerified;

  //       if (!verificationChecked || !isUserVerified) {
  //         try {
  //           const response = await axios.get(
  //             `${process.env.REACT_APP_SECRET}/api/GoTasteUser/GetIsUserVerified/${userId}`,
  //           );
  //           verified = response.data;
  //           setIsUserVerified(verified);
  //           setVerificationChecked(true);
  //         } catch (error) {
  //           console.error("Verification check failed:", error);
  //           verified = false;
  //         }
  //       }

  //       if (!verified) {
  //         setShowVerificationModal(true);
  //         setModalOpen(false);
  //         return;
  //       }
  //     }

  //     else {
  //       const response = await axios.get(
  //         `${process.env.REACT_APP_SECRET}/api/Cart/GetLoyaltyPointCount/${userId}`,
  //       );

  //       if (response.data > 1 && !isUserVerified) {

  //         setShowVerificationModal(true);
  //         return;
  //       }

  //       proceedWithOrderSubmission();
  //     }

  //     if (userCartData.length > 0) {
  //       try {
  //         setModalOpen(true);
  //         var cartId = "";
  //         const reqBody = userCartData.map((restaurant) => {
  //           const availableCredit = eligibleCredits.find(
  //             (credit) =>
  //               credit.restaurantId === restaurant.cartRestaurantId &&
  //               credit.eligibleForCredit,
  //           );
  //           const foodItems = restaurant.subOrders.flatMap((subOrder) =>
  //             subOrder.itemDetails.map((item) => ({
  //               foodItemId: item.foodItemId,
  //               foodItemName: item.foodItemName,
  //             })),
  //           );
  //           cartId = restaurant.cartId;
  //           return {
  //             cartId: restaurant.cartId,
  //             restaurantId: restaurant.cartRestaurantId,
  //             tip: restaurantTips[restaurant.cartRestaurantId] || 0,
  //             appliedCredit: availableCredit
  //               ? availableCredit.creditLimitPerOrder
  //               : 0,
  //             foodItems,
  //             isServiceChargeAdded:
  //               serviceChargeEnabledByRestaurant[restaurant.cartRestaurantId] ??
  //               false,
  //           };
  //         });
  //         const paymentDataArray = userCartData.map((restaurant) => {
  //           const rId = restaurant.cartRestaurantId;
  //           const perSC = serviceChargeByRestaurant[rId] || 0;
  //           const perSCVat = serviceChargeVatByRestaurant[rId] || 0;
  //           let rSubTotal = 0;
  //           let rTotalVAT = 0;
  //           let rTotalSD = 0;
  //           restaurant.subOrders?.forEach((subOrder) => {
  //             subOrder.itemDetails.forEach((item) => {
  //               rSubTotal += item.basePrice * item.foodItemQuantity;
  //               rTotalVAT += item.vatInAmount * item.foodItemQuantity;
  //               rTotalSD += item.sdInAmount * item.foodItemQuantity;
  //               (item.addOns || []).forEach((addOn) => {
  //                 rSubTotal += addOn.addOnBasePrice * addOn.addOnQuantity;
  //                 rTotalVAT += addOn.addOnVatAmount * addOn.addOnQuantity;
  //                 rTotalSD += addOn.addOnSdAmount * addOn.addOnQuantity;
  //                 (addOn.options || []).forEach((option) => {
  //                   rSubTotal += option.optionBasePrice * option.optionQuantity;
  //                   rTotalVAT += option.optionVatAmount * option.optionQuantity;
  //                   rTotalSD += option.optionSdAmount * option.optionQuantity;
  //                   (option.subOptions || []).forEach((subOption) => {
  //                     const qty = subOption.subOptionQuantity ?? 1;
  //                     rSubTotal += subOption.subOptionBasePrice * qty;
  //                     rTotalVAT += (subOption.subOptionVatAmount ?? 0) * qty;
  //                     rTotalSD += (subOption.subOptionSdAmount ?? 0) * qty;
  //                   });
  //                 });
  //               });
  //             });
  //           });
  //           const hasOnline = restaurant.subOrders?.some(
  //             (so) => so.orderTypeName === "Online",
  //           );
  //           const rDeliveryCharge = hasOnline ? baseDeliveryCharge : 0;
  //           const rTips = restaurantTips[rId] || 0;
  //           const rTotalAmount =
  //             rSubTotal +
  //             rTotalSD +
  //             rTotalVAT +
  //             perSC +
  //             perSCVat +
  //             rTips +
  //             rDeliveryCharge;
  //           return {
  //             id: "",
  //             orderId: restaurant.cartId,
  //             totalAmount: Number(rTotalAmount.toFixed(2)),
  //             totalVAT: Number(rTotalVAT.toFixed(2)),
  //             totalSD: Number(rTotalSD.toFixed(2)),
  //             totalTips: Number(rTips.toFixed(2)),
  //             totalServiceCharge: Number(perSC.toFixed(2)),
  //             totalServiceChargeVat: Number(perSCVat.toFixed(2)),
  //             totalCreditGivenToCust: 0,
  //             platformFeeId: 0,
  //             totalProcessingFees: 0,
  //             totalCaptureFees: 0,
  //             totalAuthFees: 0,
  //             orderStatusId: "pending",
  //             creationId: userId,
  //             paidPaymentDetails: {
  //               id: "",
  //               orderPaymentId: "",
  //               paidAmount: Number(rTotalAmount.toFixed(2)),
  //               remainingAmount: 0,
  //               paymentDate: new Date().toISOString(),
  //               paymentTypeId: "",
  //             },
  //           };
  //         });
  //         const fullOrderData = {
  //           timestamp: new Date().toISOString(),
  //           confirmedOrders: reqBody,
  //           paymentDetails: paymentDataArray,
  //           requestPayloads: {
  //             orders: reqBody,
  //             tips: userCartData.map((r) => ({
  //               cartId: r.cartId,
  //               tip: restaurantTips[r.cartRestaurantId] || 0,
  //             })),
  //           },
  //         };
  //         localStorage.setItem("lastOrderData", JSON.stringify(fullOrderData));
  //         console.log("Order data saved with service charge status:", {
  //           serviceChargeEnabledByRestaurant,
  //           serviceChargeVat,
  //           reqBody: reqBody.map((order) => ({
  //             cartId: order.cartId,
  //             restaurantId: order.restaurantId,
  //             isServiceChargeAdded: order.isServiceChargeAdded,
  //           })),
  //           paymentData: paymentDataArray.map((payment) => ({
  //             orderId: payment.orderId,
  //             totalServiceCharge: payment.totalServiceCharge,
  //             totalServiceChargeVat: payment.totalServiceChargeVat,
  //           })),
  //         });

  //         const totalAmount = Number(
  //           (
  //             Number(subTotal || 0) +
  //             Number(totalSD || 0) +
  //             Number(totalVAT || 0) +
  //             Number(totalServiceCharge || 0) +
  //             Number(serviceChargeVat || 0) +
  //             Number(totalTips || 0) +
  //             Number(deliveryCharge || 0) -
  //             Number(totalEligibleCredit || 0)
  //           ).toFixed(2),
  //         );
  //         const response = await axios.get(
  //           `${process.env.REACT_APP_SECRET}/api/Order/GetPaymentDetails?email=` +
  //             userDetails.UserEmail +
  //             "&amount=" +
  //             totalAmount +
  //             "&returnUrl=" +
  //             null,
  //         );

  //         localStorage.setItem(
  //           "checkoutDetails",
  //           JSON.stringify(response.data),
  //         );
  //         const checkout = {
  //           id: userDetails.UserId,
  //           orderPaymentId: cartId,
  //           resultCode: response.data?.result.code ?? "",
  //           resultDescription: response.data?.result.description ?? "",
  //           buildNumber: response.data.buildNumber ?? "",
  //           timestampUtc: new Date(response.data.timestamp),
  //           ndc: response.data.ndc ?? "",
  //           transactionId: response.data.id ?? "",
  //           integrityHash: response.data.integrity ?? "",
  //           createdAt: new Date().toISOString(),
  //         };
  //         await axios
  //           .post(
  //             `${process.env.REACT_APP_SECRET}/api/Order/InsertCartPaymentAttempts`,
  //             checkout,
  //           )
  //           .then((response) => {
  //             console.log(
  //               "Checkout details inserted successfully:",
  //               response.data,
  //             );
  //           })
  //           .catch((error) => {
  //             console.error("Error inserting checkout details:", error);
  //           });
  //         setCheckOutId(response.data.id);
  //       } catch (error) {
  //         console.error("Error in order/payment processing:", error);
  //         if (
  //           error.response &&
  //           typeof error.response.data === "string" &&
  //           error.response.data.includes("is in wait state")
  //         ) {
  //           toast.error(error.response.data);
  //         } else {
  //           toast.error("Error processing order. Please try again.");
  //         }
  //       }
  //     }
  //   } else if (response.data === false) {
  //     setShowModal(true);
  //   }
  // };

  //updated onSubmit function, all logic in "proceedWithOrderSubmission" function
  const onSubmit = async () => {
    if (isSubmitting) return;

    // ✅ FIX: Force a fresh check right before validation
    let currentVerificationStatus = isUserVerified;

    // Optional: Show a small loading state here if you want better UX
    // setModalOpen(true);

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SECRET}/api/GoTasteUser/GetIsUserVerified/${userId}`,
      );
      currentVerificationStatus = response.data;

      // Update state so the UI reflects this immediately too
      setIsUserVerified(currentVerificationStatus);
      setVerificationChecked(true);
    } catch (error) {
      console.error("Verification check failed during submission:", error);
      currentVerificationStatus = false;
    }

    if (hasDeliveryOrCollection) {
      // ✅ Use the freshly fetched variable, not the stale state
      if (!currentVerificationStatus) {
        console.log("111", currentVerificationStatus); // This will now show the real-time value
        setShowVerificationModal(true);
        return;
      }
    } else {
      // Loyalty path logic
      if (!currentVerificationStatus) {
        const response = await axios.get(
          `${process.env.REACT_APP_SECRET}/api/Cart/GetLoyaltyPointCount/${userId}`,
        );
        if (response.data > 1) {
          toast.info(`User needs to verify account to redeem loyalty points.`);
          setShowVerificationModal(true);
          return;
        }
      }
    }

    // If we passed all checks, proceed
    proceedWithOrderSubmission(false);
  };

  const filteredCartData = cartData?.filter((item) => item?.isOrdered === true);

  const CalculateItemTotalPrice = (item) => {
    let totalPrice = item.itemBasePrice * item.qunatity;
    if (item.options && item.options.length > 0) {
      item.options.forEach((option) => {
        totalPrice += option.basePrice * option.quantity;
        if (option.suboptions && option.suboptions.length > 0) {
          option.suboptions.forEach((suboption) => {
            totalPrice += suboption.price * suboption.quantity;
          });
        }
      });
    }
    return totalPrice.toFixed(2);
  };

  const AddAdditionalCost = (totalCost, item) => {
    var vat, deliveryCharge, platformCharge;
    vat = deliveryCharge = platformCharge = 1.5;
    totalCost += vat * item.qunatity;
    totalCost += deliveryCharge;
    totalCost += platformCharge;
    return totalCost;
  };

  const CalculateTotalPrice = (restaurantData) => {
    const { itemDetails } = restaurantData;
    let subTotal = 0;
    let totalPrice = 0;
    itemDetails?.forEach((item) => {
      subTotal += CalculateItemTotalPrice(item);
      totalPrice += AddAdditionalCost(subTotal, item);
    });
    return { subTotal, totalPrice };
  };

  const [subTotal, setSubTotal] = useState(0);
  const [totalSD, setTotalSD] = useState(0);
  const [totalVAT, setTotalVAT] = useState(0);
  const [totalVatOnSd, setTotalVatOnSd] = useState(0);
  const baseDeliveryCharge = 20;
  const countOnlineRestaurants = userCartData?.reduce((count, restaurant) => {
    const hasOnlineOrder = restaurant.subOrders.some(
      (subOrder) => subOrder.orderTypeName === "Online",
    );
    return hasOnlineOrder ? count + 1 : count;
  }, 0);
  const deliveryCharge = baseDeliveryCharge * countOnlineRestaurants;

  useEffect(() => {
    const calculateTotalBasePrice = () => {
      let subTotal = 0;
      let totalVat = 0;
      let totalSd = 0;
      let totalVatOnSd = 0;
      cartData?.forEach((data) => {
        data.subOrders?.forEach((subOrder) => {
          subOrder.itemDetails.forEach((item) => {
            subTotal += item.basePrice * item.foodItemQuantity;
            totalVat += item.vatInAmount * item.foodItemQuantity;
            totalSd += item.sdInAmount * item.foodItemQuantity;
            totalVatOnSd += item.vatOnSdInAmount * item.foodItemQuantity;
            (item.addOns || []).forEach((addOn) => {
              subTotal += addOn.addOnBasePrice * addOn.addOnQuantity;
              totalVat += addOn.addOnVatAmount * addOn.addOnQuantity;
              totalSd += addOn.addOnSdAmount * addOn.addOnQuantity;
              totalVatOnSd += addOn.addOnVatOnSdAmount * addOn.addOnQuantity;
              // Calculate options for each add-on
              (addOn.options || []).forEach((option) => {
                subTotal += option.optionBasePrice * option.optionQuantity;
                totalVat += option.optionVatAmount * option.optionQuantity;
                totalSd += option.optionSdAmount * option.optionQuantity;
                totalVatOnSd +=
                  option.optionVatOnSdAmount * option.optionQuantity;
                // Calculate sub-options for each option
                (option.subOptions || []).forEach((subOption) => {
                  subTotal +=
                    subOption.subOptionBasePrice * subOption.subOptionQuantity;
                  totalVat +=
                    subOption.subOptionVatAmount * subOption.subOptionQuantity;
                  totalSd +=
                    subOption.subOptionSdAmount * subOption.subOptionQuantity;
                  totalVatOnSd +=
                    subOption.subOptionVatOnSdAmount * option.optionQuantity;
                });
              });
            });
          });
        });
      });
      setTotalSD(totalSd);
      setTotalVAT(totalVat);
      setSubTotal(subTotal);
      setTotalVatOnSd(totalVatOnSd);
    };
    calculateTotalBasePrice();
  }, [cartData]);

  const fetchPendingOrders = useCallback(async (userId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SECRET}/api/Order/GetPendingOrderDataByUserId?userId=${userId}`,
      );
      setOrderData(response.data);
    } catch (error) {
      console.error("Error fetching order data:", error);
    }
  }, []);

  // console.log("SSSR: ", orderData[0]?.subOrders[0]?.orderTypeName);
  console.log("SSSR: ", orderData);

  useEffect(() => {
    const token = localStorage.getItem("gotasteClienttoken");
    if (token) {
      const userId = jwtDecode(token).UserId;
      fetchPendingOrders(userId);
    }
  }, [fetchPendingOrders]);

  useEffect(() => {
    const flattenArray = (data) => {
      const itemDetails = data.flatMap(
        (order) => order.subOrders.flatMap((subOrder) => subOrder.itemDetails),
        // order.subOrders.flatMap((subOrder) => subOrder.itemDetails),
      );
      setFlattenFoodItems(itemDetails);
    };
    if (orderData.length > 0) {
      flattenArray(orderData);
    }
  }, [orderData]);

  const handleClickOpen = () => {
    setopenPaymentDialog(true);
  };

  const handleClose = () => {
    setopenPaymentDialog(false);
  };

  const DeliverySelfCollectionState = (subOrder) => {
    setDeliveryAddress((prevItems) => {
      const existingItem = prevItems.find(
        (item) => item.subOrderId === subOrder.subOrderId,
      );
      if (existingItem) {
        return prevItems.map((item) =>
          item.subOrderId === subOrder.subOrderId
            ? { ...item, active: !item.active }
            : item,
        );
      } else {
        return [
          ...prevItems,
          { subOrderId: subOrder.subOrderId, active: true },
        ];
      }
    });
  };

  useEffect(() => {
    if (deliveryAddress?.length === 0) {
      setHasDisabledDelivery(showDeliveryAddress);
      return;
    }
    const result =
      deliveryAddress.filter((item) => item.active === true).length !==
      userCartData.reduce(
        (count, cart) =>
          count +
          cart.subOrders.reduce(
            (subCount, subOrder) =>
              subCount +
              subOrder.itemDetails.filter((item) => item.isDelivery === true)
                .length,
            0,
            0,
          ),
        0,
        0,
      );
    // console.log("MKMK", result)
    setHasDisabledDelivery(result);
  }, [userCartData, deliveryAddress]);

  const getQRCode = (orderId) => {
    setQrOrderId(orderId);
    setShowQR(true);
  };

  useEffect(() => {
    const calculateTotalCredit = () => {
      const creditEligibility = [];
      let totalEligibleCredit = 0;
      userCartData?.forEach((data) => {
        let subTotal = 0;
        data.subOrders?.forEach((subOrder) => {
          subOrder.itemDetails.forEach((item) => {
            subTotal +=
              item.basePrice * item.foodItemQuantity +
              item.vatInAmount * item.foodItemQuantity +
              item.sdInAmount * item.foodItemQuantity +
              item.vatOnSdInAmount * item.foodItemQuantity;
            (item.addOns || []).forEach((addOn) => {
              subTotal +=
                addOn.addOnBasePrice * addOn.addOnQuantity +
                addOn.addOnVatAmount * addOn.addOnQuantity +
                addOn.addOnSdAmount * addOn.addOnQuantity +
                addOn.addOnVatOnSdAmount * addOn.addOnQuantity;
              (addOn.options || []).forEach((option) => {
                subTotal +=
                  option.optionBasePrice * option.optionQuantity +
                  option.optionVatAmount * option.optionQuantity +
                  option.optionSdAmount * option.optionQuantity +
                  option.optionVatOnSdAmount * option.optionQuantity;
                (option.subOptions || []).forEach((subOption) => {
                  subTotal +=
                    subOption.subOptionBasePrice * subOption.subOptionQuantity +
                    subOption.subOptionVatAmount * subOption.subOptionQuantity +
                    subOption.subOptionSdAmount * subOption.subOptionQuantity +
                    subOption.subOptionVatOnSdAmount *
                      subOption.subOptionQuantity;
                });
              });
            });
          });
        });
        const isEligible =
          subTotal >= data.minimumOrderPriceToGiveCredit &&
          data.restaurantCredit !== 0;
        if (isEligible) {
          totalEligibleCredit += data.creditLimitPerOrder;
        }
        creditEligibility.push({
          restaurantId: data.cartRestaurantId,
          subTotal: subTotal.toFixed(2),
          eligibleForCredit: isEligible,
          creditLimitPerOrder: data.creditLimitPerOrder,
          restaurantCredit: data.restaurantCredit,
        });
      });
      setEligibleCredits(creditEligibility);
      setTotalEligibleCredit(totalEligibleCredit);
    };
    if (userCartData?.length > 0) {
      calculateTotalCredit();
    }
  }, [userCartData]);

  useEffect(() => {
    const price = (
      subTotal +
      totalSD +
      totalVAT +
      // totalServiceCharge * 0.2 +
      totalServiceCharge +
      totalVatOnSd +
      totalTips +
      deliveryCharge
    ).toFixed(2);
    if (price > 0) {
      const gotasteClienttoken = localStorage.getItem("gotasteClienttoken");
      var decoded = {};
      if (gotasteClienttoken != null) {
        try {
          decoded = jwtDecode(gotasteClienttoken);
        } catch (error) {
          console.log(error);
        }
      }
      const apiAddress = process.env.REACT_APP_SECRET;
      axios({
        method: "get",
        url: `${apiAddress}/api/GoTasteUser/GetGoTasteUserByIdForCheckout/${decoded.UserId}`,
      })
        .then((res) => {
          const paymentData = {
            email: res.data.email,
            amount: price,
          };
          axios
            .post(`${process.env.REACT_APP_SECRET}/api/Payment`, paymentData)
            .then((res2) => {
              if (res2.data) {
                setCheckOutId(res2.data);
                console.log("checkout id", res2.data);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [
    subTotal,
    totalSD,
    totalVAT,
    totalServiceCharge,
    totalTips,
    deliveryCharge,
  ]);

  console.log("userCartData", userCartData, hasDisabledDelivery);

  return (
    <div>
      <ToastContainer />

      <Navbar handleNavbar={searchDialogOpen} />
      <div ref={checkOutTopRef}></div>
      <div className={`${blur ? "BackBlur" : ""}`}>
        <div className="container checkout-container">
          <div>
            <Tabs
              id="controlled-tab-example"
              activeKey={key}
              // onSelect={(k) => setKey(k)}
              onSelect={onTabSelect}
              className="mb-3"
            >
              <Tab eventKey="active" title="ACTIVE">
                <div className="checkout-active-main-tab d-flex gap-1">
                  <div className="col-md-6">
                    <div className="col-12">
                      <div>
                        {userCartData?.length > 0 && (
                          <SelfCollectionCard
                            userCartData={userCartData}
                            // selectedAddressId={selectedAddressId}
                            handleAddressSelect={handleAddressSelect}
                            changeDeliveryAddress={changeDeliveryAddress}
                            handleCloseUpdateModal={handleCloseUpdateModal}
                            handleDeleteAddress={handleDeleteAddress}
                            handleUpdateDefaultAddress={
                              handleUpdateDefaultAddress
                            }
                            showAddressError={showAddressError}
                            dataOfSwitchToSelfCollection={deliveryAddress}
                          />
                        )}
                        <br />
                        {/* {userCartData?.length > 0 && hasDisabledDelivery && (
                        <DeliveryAddressCard
                          address={address}
                          // selectedAddressId={selectedAddressId}
                          handleAddressSelect={handleAddressSelect}
                          changeDeliveryAddress={changeDeliveryAddress}
                          handleCloseUpdateModal={handleCloseUpdateModal}
                          handleDeleteAddress={handleDeleteAddress}
                          handleUpdateDefaultAddress={
                            handleUpdateDefaultAddress
                          }
                          showAddressError={showAddressError}
                          handleShowAddressModal={handleShowAddressModal}
                        />
                      )} */}
                        {userCartData?.length > 0 && hasDisabledDelivery && (
                          <DeliveryAddressCard
                            address={address}
                            readonly={true}
                          />
                        )}
                        {userCartData?.[0]?.subOrders?.map((subOrder) => {
                          const isInStore =
                            subOrder.orderTypeName === "In-Store";
                          const isDeliveryOrder =
                            subOrder.orderTypeName === "Delivery";
                          const hasSelfCollection =
                            isDeliveryOrder &&
                            subOrder.itemDetails.some(
                              (item) =>
                                item.isDelivery === true &&
                                item.isDeliveryOff === false &&
                                item.isCollectionOnly === true,
                            );
                          const hasDelivery =
                            isDeliveryOrder &&
                            subOrder.itemDetails.some(
                              (item) =>
                                item.isDelivery === true &&
                                item.isDeliveryOff === false &&
                                item.isCollectionOnly === false,
                            );
                          return (
                            <div key={subOrder.subOrderId}>
                              {/* {isInStore && <DineInCard
                            subOrder={subOrder}
                            userCartData={userCartData}
                            selectedAddressId={selectedAddressId}
                            handleAddressSelect={handleAddressSelect}
                            changeDeliveryAddress={changeDeliveryAddress}
                            handleCloseUpdateModal={handleCloseUpdateModal}
                            handleDeleteAddress={handleDeleteAddress}
                            handleUpdateDefaultAddress={handleUpdateDefaultAddress}
                            showAddressError={showAddressError}
                            dataOfSwitchToSelfCollection={deliveryAddress}
                          />} */}
                              {hasSelfCollection && (
                                <SelfCollectionCard
                                  subOrder={subOrder}
                                  userCartData={userCartData}
                                  // ❌ old prop removed
                                  // selectedAddressId={selectedAddressId}
                                  selectedAddressId={null}
                                  handleAddressSelect={handleAddressSelect}
                                  changeDeliveryAddress={changeDeliveryAddress}
                                  handleCloseUpdateModal={
                                    handleCloseUpdateModal
                                  }
                                  handleDeleteAddress={handleDeleteAddress}
                                  handleUpdateDefaultAddress={
                                    handleUpdateDefaultAddress
                                  }
                                  showAddressError={showAddressError}
                                  dataOfSwitchToSelfCollection={deliveryAddress}
                                />
                              )}
                              {/* removed delivery address card */}
                              {/* {hasDelivery && (
                              <DeliveryAddressCard
                                subOrder={subOrder}
                                address={address}
                                selectedAddressId={selectedAddressId}
                                handleAddressSelect={handleAddressSelect}
                                changeDeliveryAddress={changeDeliveryAddress}
                                handleCloseUpdateModal={
                                  handleCloseUpdateModal
                                }
                                handleDeleteAddress={handleDeleteAddress}
                                handleUpdateDefaultAddress={
                                  handleUpdateDefaultAddress
                                }
                                showAddressError={showAddressError}
                                handleShowAddressModal={
                                  handleShowAddressModal
                                }
                              />
                            )} */}
                              <br />
                            </div>
                          );
                        })}
                        <DeleteConfirmationModal
                          showModal={showDeleteConfirmation}
                          handleClose={() => setShowDeleteConfirmation(false)}
                          handleConfirmDelete={handleConfirmDelete}
                        />
                        <AddressChangeModal
                          showModal={showAddressModal}
                          handleClose={handleCloseAddressModal}
                          changeAddress={changeAddress}
                          userId={userId}
                        />
                        <AddressUpdateModal
                          showModal={showUpdateModal}
                          handleClose={() => setShowUpdateModal(false)}
                          // setAddress={setAddress}
                          addressData={selectedAddressForUpdate}
                          handleUpdate={(updatedAddress) => {
                            // Handle the updated address data here, e.g., update the state
                            const updatedAddresses = address.map(
                              (a) =>
                                a.id === updatedAddress.id ? updatedAddress : a,
                              // a.id === updatedAddress.id ? updatedAddress : a,
                            );
                            setAddress(updatedAddresses);
                          }}
                        />
                      </div>
                      <br />
                      <div className="checkOutCard">
                        <PersonalDetails />
                      </div>
                      <br />
                      {/* <div className='checkOutCard'>
                      <h4 className='DeliveryHeader'>Coupon</h4>
                      <div className='row'>
                        <div className='col-8'>
                          <div className='deliveryDetails'>
                            <div className='d-flex locaionDetails'>
                              <div className='d-flex flex-column addressCheckOut'>
                                <div>
                                  <input
                                    type='text'
                                    placeholder='Enter voucher code'
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='col-4 d-flex align-items-start justify-content-end'>
                          <button className='btn btn-primary'>Apply</button>
                        </div>
                      </div>
                    </div> */}
                      {/* <br /> */}
                      {/* --Payment Section-- */}
                      <div className="checkOutCard">
                        <h4 className="DeliveryHeader">Payment</h4>
                        <PaymentOptions />
                      </div>{" "}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="sticky-position">
                      <div className="col-12">
                        <div className="checkOutCard shadow-none px-2 sticky-position">
                          <h4 className="DeliveryHeader">Your order from</h4>

                          {/* updated mapper with hasDelivery */}
                          {userCartData?.map((restaurant, index) => {
                            // ✅ Compute hasDelivery per restaurant
                            const hasDelivery = restaurant.subOrders.some(
                              (subOrder) =>
                                subOrder.orderTypeName === "Delivery" &&
                                subOrder.itemDetails.some(
                                  (item) =>
                                    item.isDelivery === true &&
                                    item.isDeliveryOff === false &&
                                    item.isCollectionOnly === false,
                                ),
                              // ,
                              //     item.isCollectionOnly === false,
                              // ),
                            );
                            // ✅ Get per-restaurant selected address ID
                            const selectedAddressId =
                              selectedAddressIdByRestaurant[
                                restaurant.cartRestaurantId
                              ] || null;
                            const deliveryFee =
                              deliveryFeeByRestaurant[
                                restaurant.cartRestaurantId
                              ] || 0;
                            console.log("deliveryFee", deliveryFee);

                            return (
                              <div key={restaurant.cartRestaurantId}>
                                <RestaurantOrderDetails
                                  key={restaurant.cartRestaurantId}
                                  restaurant={restaurant}
                                  restaurantIndex={index}
                                  handleSetTip={handleSetTip}
                                  slectedTableHistroyForValidation={
                                    setSelectedTable
                                  }
                                  tips={
                                    restaurantTips[
                                      restaurant.cartRestaurantId
                                    ] || 0
                                  }
                                  setIsToggleOn={setIsToggleOn}
                                  isToggleOn={isToggleOn}
                                  DeliverySelfCollectionStateInParent={
                                    DeliverySelfCollectionState
                                  }
                                  isServiceChargeEnabled={
                                    serviceChargeEnabledByRestaurant[
                                      restaurant.cartRestaurantId
                                    ] ?? true
                                  }
                                  handleServiceChargeToggle={() =>
                                    handleServiceChargeToggle(
                                      restaurant.cartRestaurantId,
                                      restaurant.cartRestaurantId,
                                    )
                                  }
                                  hasDelivery={hasDelivery}
                                  // ✅ new props with per-restaurant context
                                  address={address}
                                  selectedAddressId={selectedAddressId}
                                  handleAddressSelect={(id) =>
                                    handleAddressSelect(
                                      restaurant.cartRestaurantId,
                                      id,
                                      id,
                                    )
                                  }
                                  changeDeliveryAddress={changeDeliveryAddress}
                                  onUpdateDeliveryNote={updateDeliveryNote}
                                  handleCloseUpdateModal={
                                    handleCloseUpdateModal
                                  }
                                  handleDeleteAddress={handleDeleteAddress}
                                  handleUpdateDefaultAddress={
                                    handleUpdateDefaultAddress
                                  }
                                  showAddressError={showAddressError}
                                  handleShowAddressModal={
                                    handleShowAddressModal
                                  }
                                  deliveryFee={deliveryFee}
                                  deliveryDistance={deliveryDistance}
                                  deliveryDuration={deliveryDuration}
                                  onSubOrderTypeChange={
                                    handleSubOrderTypeChange
                                  }
                                />
                              </div>
                            );
                          })}
                          <div>
                            {/* <div className='order-container'>
                            {cartData?.map((restaurant) => {
                              return (
                                <div key={restaurant.restaurantId}>
                                  <div className='orderDetails ms-3'>
                                    <h5>
                                      <b>{restaurant.restaurantName}</b>
                                    </h5>
                                  </div>
                                  {restaurant?.itemDetails?.map((item) => {
                                    return (
                                      <div className='pb-2 me-3'>
                                        <div key={item?.itemId}>
                                          <div className='d-flex justify-content-between ms-3 orderDetails'>
                                            <h5>
                                              {item.qunatity} x {item.itemName}
                                            </h5>
                                            <h5>£{item.itemBasePrice}</h5>
                                          </div>
                                        </div>
                                        <div className='ps-5 text-black-50'>
                                          {item?.options.map((option) => {
                                            return (
                                              option.quantity > 0 && (
                                                <h6 key={option.id}>
                                                  +{option.optionName} x
                                                  {option.quantity}
                                                  <span>
                                                    {" "}
                                                    £{option.unitPrice}{" "}
                                                  </span>
                                                  {option?.suboptions.map(
                                                    (suboption) => {
                                                      return (
                                                        suboption.quantity >
                                                          0 && (
                                                          <span
                                                            key={suboption.id}
                                                          >
                                                            (
                                                            {
                                                              suboption.suboptionName
                                                            }{" "}
                                                            x
                                                            {
                                                              suboption.quantity
                                                            }{" "}
                                                            £
                                                            {
                                                              suboption.unitPrice
                                                            }
                                                            )
                                                          </span>
                                                        )
                                                      );
                                                    }
                                                  )}
                                                  <br />
                                                </h6>
                                              )
                                            );
                                          })}
                                        </div>
                                      </div>
                                    );
                                  })}
                                  <hr />
                                  <div className='me-3 extra-charges'>
                                    <div className='d-flex justify-content-between ms-3 orderDetails'>
                                      <h5>SD</h5>
                                      <h5>£4</h5>
                                    </div>
                                    <div className='d-flex justify-content-between ms-3 orderDetails'>
                                      <h5>VAT</h5>
                                      <h5>£4</h5>
                                    </div>
                                    <div className='d-flex justify-content-between ms-3 orderDetails'>
                                      <h5>TOTAL</h5>
                                      <h5>£4</h5>
                                    </div>
                                  </div>
                                  <hr></hr>
                                </div>
                              );
                            })}
                          </div> */}
                            {/* <div className='d-flex justify-content-between ms-3 orderDetails'>
                            <h5>Subtotal</h5>
                            <h5>£{state?.subtotal}</h5>
                          </div> */}
                          </div>
                          {/* Pricing area */}
                          <div className="d-flex justify-content-between ms-3 orderDetails">
                            <h5>SubTotal</h5>
                            <h5>£{subTotal.toFixed(2)}</h5>
                          </div>
                          <div className="d-flex justify-content-between ms-3 orderDetails">
                            <h5>Total VAT Inc. SD</h5>
                            {/* <h5
                            className='text-primary text-decoration-underline text-cursor-pointer'
                            onClick={() => setModalShow(true)}
                          >
                            £
                            {(
                              totalSD +
                              totalVAT +
                              totalServiceCharge * 0.2
                            ).toFixed(2)}
                          </h5> */}
                            <h5
                              className="text-primary text-decoration-underline text-cursor-pointer"
                              onClick={() => setModalShow(true)}
                            >
                              £
                              {(
                                totalSD +
                                totalVAT +
                                totalVatOnSd +
                                serviceChargeVat
                              ).toFixed(2)}
                            </h5>
                          </div>
                          <div className="d-flex justify-content-between ms-3 orderDetails">
                            <h5>Total Service Charge Exc. VAT</h5>
                            <h5
                              className="text-primary text-decoration-underline text-cursor-pointer"
                              onClick={() => setModalShow(true)}
                            >
                              £{totalServiceCharge.toFixed(2)}
                            </h5>
                          </div>
                          <div className="d-flex justify-content-between ms-3 orderDetails">
                            <h5>Total Tips</h5>
                            <h5>£{totalTips.toFixed(2)}</h5>
                          </div>
                          {/* Delivery Fee */}
                          <div className="d-flex justify-content-between ms-3 orderDetails">
                            <h5>Delivery Fee Inc. VAT (20%)</h5>
                            <h5>
                              £
                              {deliveryEstimate.loading
                                ? "..."
                                : deliveryEstimate.error
                                  ? "—"
                                  : deliveryEstimate.fee.toFixed(2)}
                            </h5>
                          </div>
                          <div className="d-flex justify-content-between ms-3 orderDetails">
                            <h5>Total Credits</h5>
                            <h5>- £{totalEligibleCredit?.toFixed(2)}</h5>
                          </div>
                          <OrderDetailsModal
                            show={modalShow}
                            totalTips={totalTips}
                            onHide={() => setModalShow(false)}
                            userCartData={userCartData}
                            totalServiceCharge={totalServiceCharge}
                            deliveryCharge={deliveryCharge}
                            serviceChargeEnabledByRestaurant={
                              serviceChargeEnabledByRestaurant
                            }
                            handleServiceChargeToggle={
                              handleServiceChargeToggle
                            }
                          />
                          {/* <div className="d-flex justify-content-between ms-3 orderDetails">
                          <h5>SC</h5>
                          <h5>£1.50</h5>
                        </div> */}
                          {/* <div className='d-flex justify-content-between ms-3 orderDetails'>
                          <h5>VAT</h5>
                          <h5>£1.50</h5>
                        </div> */}
                          {/* <div className='d-flex justify-content-between ms-3 orderDetails'>
                          <h5>Delivery Fee</h5>
                          <h5>£1.50</h5>
                        </div> */}
                          {/* <div className='d-flex justify-content-between ms-3 orderDetails'>
                          <h5>Platform Fee</h5>
                          <h5>£1.50</h5>
                        </div> */}
                          {showCartDataError && (
                            <p className="text-danger ps-2">
                              Please add items to your cart
                            </p>
                          )}
                          {/* <hr></hr> */}
                          <div className="d-flex justify-content-between ms-3">
                            <h5 className="fs-4 fw-bold">Total Price</h5>
                            {/* <h5 className='fs-4 fw-bold'>
                            £
                            {(
                              subTotal +
                              totalSD +
                              totalVAT +
                              totalServiceCharge * 0.2 +
                              totalServiceCharge +
                              totalTips +
                              deliveryCharge -
                              totalEligibleCredit
                            ).toFixed(2)}
                          </h5> */}
                            <h5 className="fs-4 fw-bold">
                              £
                              {(
                                subTotal +
                                totalSD +
                                totalVAT +
                                totalVatOnSd +
                                serviceChargeVat +
                                totalServiceCharge +
                                totalTips +
                                deliveryEstimate.fee -
                                totalEligibleCredit
                              ).toFixed(2)}
                            </h5>
                          </div>
                          <div className="d-flex ms-3 pb-2">
                            <span className="text-muted">(Incl. VAT)</span>
                          </div>
                          <div
                            className="d-flex justify-content-between ms-3 orderDetails warning-allergies mb-1"
                            style={{ textAlign: "justify" }}
                          >
                            <p>
                              ALLERGIES: If you or someone you’re ordering for
                              has an allergy, please contact the merchant
                              directly to let them know. If you’re not around
                              when the delivery person arrives, they’ll leave
                              your order at the door. By placing your order, you
                              agree to take full responsibility for it once it’s
                              delivered. Orders containing alcohol or other
                              restricted items may not be eligible for leave at
                              door and will be returned to the store if you are
                              not available. Whilst we, and our restaurant
                              partners, have safety measures to mitigate food
                              safety risk, couriers may be delivering more than
                              one order so we cannot eliminate the risk of
                              cross-contamination from allergens.
                            </p>
                          </div>

                          {waitStateItems.length > 0 && (
                            <>
                              <WaitStatusList waitStateItems={waitStateItems} />
                            </>
                          )}
                          <div
                            className={`d-flex align-items-center restaurantNameDisplay btnCheckOut ${
                              slideUp
                                ? "btnCheckOutMarginTopZero "
                                : "btnCheckOutMarginTop"
                            }`}
                            onClick={onSubmit}
                          >
                            <button
                              className="btn btn-dark w-100 btn-placeOrder"
                              data-mdb-ripple-init
                            >
                              Place Order
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab>
              <Tab eventKey="pending" title="PENDING" className="mb-5">
                <PendingOrderAccordion
                  GetQRCode={getQRCode}
                  orders={pendingOrders}
                  type="pending"
                />
              </Tab>
              <Tab eventKey="history" title="HISTORY">
                <PendingOrderAccordion orders={historyOrders} type="history" />
              </Tab>
              <Tab eventKey="loyality" title="LOYALITY">
                <LoyalitySchemeAccordion />
              </Tab>
            </Tabs>
          </div>
        </div>
      </div>

      {modalOpen && (
        <LoadingModal open={modalOpen} onClose={() => setModalOpen(false)} />
      )}

      <Dialog
        open={openPaymentDialog}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: { zIndex: 1400 },
        }}
      >
        <DialogContent>
          <form
            action={returnUrl}
            class="paymentWidgets"
            data-brands="VISA MASTER"
          ></form>
        </DialogContent>
      </Dialog>
      <Footer />
      {/* Modal for Empty cart */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        backdrop="static"
        contentClassName="border-0 bg-transparent"
      >
        <Card className="text-center p-4 shadow-lg border-danger cardContainer mx-3">
          <img className="w-25 mx-auto mb-3" src={FailIcon} alt="Empty Cart" />
          <Card.Title className="text-danger fs-4 fw-bold">
            Empty Cart
          </Card.Title>
          <Card.Text className="text-muted mt-2">
            It looks like your cart is empty. <br />
            Please add items to your cart before continuing.
          </Card.Text>
          <Button
            variant="danger"
            className="w-50 mx-auto mt-4 fw-semibold"
            onClick={handleOk}
          >
            OK
          </Button>
        </Card>
      </Modal>
      {/* QR--CODE Modals */}
      <Modal show={showQR} onHide={() => setShowQR(false)} centered size="md">
        <Modal.Header closeButton>
          <Modal.Title>Order QR Code</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <QRCodeCanvas value={qrUrl} size={200} />
          <a
            href={qrUrl}
            className="d-block mt-3 px-3 py-2 bg-white border rounded text-decoration-none text-dark fw-medium"
            target="_blank"
            rel="noopener noreferrer"
          >
            Access QR Code
          </a>
          {/* <p className="text-muted mt-1">{qrUrl}</p> */}
        </Modal.Body>
      </Modal>

      {/* Verification Modal */}
      <VerificationModal
        show={showVerificationModal}
        onHide={() => setShowVerificationModal(false)}
        userId={userId}
        userEmail={userDetails?.UserEmail}
        isForLoyalty={!hasDeliveryOrCollection}
        onSkipVerification={() => {
          setTotalEligibleCredit(0);
          setEligibleCredits(
            eligibleCredits.map((ec) => ({ ...ec, eligibleForCredit: false })),
          );
          proceedWithOrderSubmission(true); // 👈 skips loyalty
        }}
      />
    </div>
  );
};

export default CheckOut;
